export default "__VITE_ASSET__3b011777__"